// const dataStructure = {
//     prices: [
//         {
//             description: String, // from stripe - eg: "Remaining time on 2 × WhatsApp File Top Up after 01 Sep 2023"
//             quantity: Number, // from stripe
//             start_time: Date, // from stripe - period.start
//             end_time: Date, // from stripe - period.end
//             plan_unit_amount: Float, // from stripe - plan.unit_amount (eg: 14.9 )
//             amount: Float, // from stripe (the prorated amount incl. tax eg: 13.07)
//             amount_excluding_tax: Float, // from stripe (the prorated amount eg: 13.07)

import { parseFromStripe } from "./parseFromStripe";

//             product_name: "WhatsApp File Top Up", // <- EXTRA: need to be inferred from plan
//         },
//     ],
//     subtotal: Float, // from stripe
//     discount_amount: Float, // from stripe
//     total_excluding_tax: Float, // from stripe
//     tax_amount: Float, // from stripe - tax
//     total: Float, // from stripe

//     amount_due: Float, // from stripe (will be 0 if credits > total)

//     billing_cycle: Number, // EXTRA: 1 or 12
//     billing_anchor_date: Date, // EXTRA: upcoming billing date (with time)
// };

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 615,
    amount_paid: 0,
    amount_remaining: 615,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694575678,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_13c46bGSTSE9ZxBo4ce708e2",
                object: "line_item",
                amount: -57475,
                amount_excluding_tax: -57475,
                currency: "myr",
                description: "Unused time on Subscription (Yearly) after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NpjkAGSTSE9ZxBoB6uYuwzg",
                livemode: false,
                metadata: {},
                period: {
                    end: 1725166698,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 59000,
                    amount_decimal: "59000",
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 59000,
                    unit_amount_decimal: "59000",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NlPR0GSTSE9ZxBoLzDJ8KZb",
                        invoice_line_items: [
                            "il_1NlPR0GSTSE9ZxBoVQoslLpL",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OYWTBa81lr7zPg",
                tax_amounts: [],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-57475",
            },
            {
                id: "il_tmp_157dc6GSTSE9ZxBo9efe4c02",
                object: "line_item",
                amount: 7450,
                amount_excluding_tax: 7450,
                currency: "myr",
                description: "5 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167678,
                    start: 1694575678,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 5,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_Oczjjpj4RZBYFn",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_13ee34GSTSE9ZxBo57ee11a1",
                object: "line_item",
                amount: 6210,
                amount_excluding_tax: 6210,
                currency: "myr",
                description: "9 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167678,
                    start: 1694575678,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 9,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczjN4oOCWEbEo",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_17155eGSTSE9ZxBo4849f145",
                object: "line_item",
                amount: 39600,
                amount_excluding_tax: 39600,
                currency: "myr",
                description: "4 × Subscription (Monthly) (at RM99.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167678,
                    start: 1694575678,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 4,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_Oczj0sXAL07EGr",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "9900",
            },
            {
                id: "il_tmp_114897GSTSE9ZxBo2f759a59",
                object: "line_item",
                amount: 4830,
                amount_excluding_tax: 4830,
                currency: "myr",
                description: "7 × User Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167678,
                    start: 1694575678,
                },
                plan: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 7,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczjxxrHrgJHsP",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
        ],
        has_more: false,
        total_count: 5,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NlPR0GSTSE9ZxBoRGYf3SSZ&subscription_proration_date=1694361600&subscription_proration_behavior=always_invoice&subscription_items%5B3%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B3%5D%5Bquantity%5D=4&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bquantity%5D=7&subscription_items%5B4%5D%5Bprice%5D=price_1Nhl5dGSTSE9ZxBorBEVOhba&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OYWTBa81lr7zPg&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=5&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&subscription_items%5B2%5D%5Bquantity%5D=9&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694575678,
    period_start: 1694575678,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694361600,
    subtotal: 615,
    subtotal_excluding_tax: 615,
    tax: null,
    test_clock: null,
    total: 615,
    total_discount_amounts: [],
    total_excluding_tax: 615,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 58090,
    amount_paid: 0,
    amount_remaining: 58090,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694575735,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_12699dGSTSE9ZxBo47d98b01",
                object: "line_item",
                amount: 7450,
                amount_excluding_tax: 7450,
                currency: "myr",
                description: "5 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167735,
                    start: 1694575735,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 5,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczkMCpWzHmOPi",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_1749ffGSTSE9ZxBof6fa6c99",
                object: "line_item",
                amount: 6210,
                amount_excluding_tax: 6210,
                currency: "myr",
                description: "9 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167735,
                    start: 1694575735,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 9,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczkldQL2Qku8m",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_195e24GSTSE9ZxBo30362c8c",
                object: "line_item",
                amount: 39600,
                amount_excluding_tax: 39600,
                currency: "myr",
                description: "4 × Subscription (Monthly) (at RM99.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167735,
                    start: 1694575735,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 4,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczkURrNFD9n6B",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "9900",
            },
            {
                id: "il_tmp_1f2e2eGSTSE9ZxBo5e8fc2a8",
                object: "line_item",
                amount: 4830,
                amount_excluding_tax: 4830,
                currency: "myr",
                description: "7 × User Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697167735,
                    start: 1694575735,
                },
                plan: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1Nhl5dGSTSE9ZxBorBEVOhba",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674229,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkaPSfG7JHKYS",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 7,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczkYSK6VcmFR4",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
        ],
        has_more: false,
        total_count: 4,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NlPR0GSTSE9ZxBoRGYf3SSZ&subscription_proration_behavior=none&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OYWTBa81lr7zPg&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B3%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B3%5D%5Bquantity%5D=4&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bprice%5D=price_1Nhl5dGSTSE9ZxBorBEVOhba&subscription_items%5B4%5D%5Bquantity%5D=7&subscription_items%5B4%5D%5Bdeleted%5D=false&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=5&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&subscription_items%5B2%5D%5Bquantity%5D=9&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694575735,
    period_start: 1694575735,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694575735,
    subtotal: 58090,
    subtotal_excluding_tax: 58090,
    tax: null,
    test_clock: null,
    total: 58090,
    total_discount_amounts: [],
    total_excluding_tax: 58090,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const DiffCycleUpgrade = parseFromStripe(today);
const DiffCycleNoProration = parseFromStripe(nextNoProration);

export const DiffCycleYearToMonthUpgradeExpected = {
    today: DiffCycleUpgrade,
    next: DiffCycleNoProration,
};
